import React, { useState } from 'react';
import { GeoJSON } from 'react-leaflet';
import { Modal, Table, Button } from 'react-bootstrap';


/**
 * @note: This component cannot be SSR'd
 */



/**
 * The default class we are using (generally)
 */
const FloodMapGeoJSONLayer = ({ geoJSON, geoJSONOpts, label }) => {
  return <GeoJSON data={geoJSON} {...geoJSONOpts} label={label} />;
};


const FloodMapGeoJSONLayerPropertyVisualiser = ({ geoJSON }) => {
    const [showModal, setShowModal] = useState(false);
    const [featureProps, setFeatureProps] = useState({});

    const onEachFeature = (feature, layer) => {
        layer.on({
            click: () => {
                setFeatureProps(feature.properties);
                setShowModal(true);
            },
        });
    };

    const handleCloseModal = () => setShowModal(false);

    const renderTable = () => {
        return (
            <Table striped bordered hover>
                <tbody>
                    {Object.entries(featureProps).map(([key, value]) => (
                        <tr key={key}>
                            <td>{key}</td>
                            <td>{value}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        );
    };

    return (
        <>
            <GeoJSON
                data={geoJSON}
                onEachFeature={onEachFeature}
                style={{
                    opacity: '43%',
                    color: 'black'
                }}
            />
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header className="text-white bg-dark" closeButton>
                    <Modal.Title>Map Feature Properties</Modal.Title>
                </Modal.Header>
                <Modal.Body>{renderTable()}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

FloodMapGeoJSONLayer.AreaClosed = ({ geoJSON, label }) => {
    let geoJSONOpts = {
        style: {
          opacity: '43%',
          color: 'red'
        }
    };
    return <FloodMapGeoJSONLayer geoJSON={geoJSON} geoJSONOpts={geoJSONOpts} label={label} />;
};


const FloodedDefenceAreaVisualiser = ({ key, geoJSON, defenceName, defenceStatus }) => {
    const [showModal, setShowModal] = useState(false);
    const [featureProps, setFeatureProps] = useState({});

    const onEachFeature = (feature, layer) => {
        layer.on({
            click: () => {
                setFeatureProps(feature.properties);
                setShowModal(true);
            },
        });
    };

    const handleCloseModal = () => setShowModal(false);

    const defenceStatusDescription = defenceStatus === 'IN_FLOOD' ? 'is flooded' : "was recently flooded";

    return (
        <>
            <GeoJSON
                key={key}
                data={geoJSON}
                onEachFeature={onEachFeature}
                style={{
                    opacity: '43%',
                    color: (defenceStatus === 'IN_FLOOD' ? 'red' : 'brown')
                }}
            />
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header className="text-white bg-dark" closeButton>
                    <Modal.Title>{defenceName || "Unknown Defence Area"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    The area highlighted by this region, known as "{defenceName || "Unknown Defence Area"}" {defenceStatusDescription}.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="dark" onClick={handleCloseModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

FloodMapGeoJSONLayer.Alert = ({ geoJSON, label }) => {
  let geoJSONOpts = {
    style: {
      opacity: '43%',
      color: 'orange'
    }
  };
  return <FloodMapGeoJSONLayer geoJSON={geoJSON} geoJSONOpts={geoJSONOpts} label={label} />;
}

FloodMapGeoJSONLayer.Warning = ({ geoJSON, label }) => {
  let geoJSONOpts = {
    style: {
      opacity: '43%',
      color: 'red'
    }
  };
  return <FloodMapGeoJSONLayer geoJSON={geoJSON} geoJSONOpts={geoJSONOpts} label={label} />;
}

FloodMapGeoJSONLayer.Severe = ({ geoJSON, label }) => {
  let geoJSONOpts = {
    style: {
      opacity: '73%',
      color: 'red'
    }
  };
  return <FloodMapGeoJSONLayer geoJSON={geoJSON} geoJSONOpts={geoJSONOpts} label={label} />;
}

FloodMapGeoJSONLayer.RoadClosure = ({ geoJSON, label }) => {
  let geoJSONOpts = {
    style: {
      opacity: '60%',
      color: 'red'
    }
  };
  return <FloodMapGeoJSONLayer geoJSON={geoJSON} geoJSONOpts={geoJSONOpts} label={label} />;
}

FloodMapGeoJSONLayer.None = ({ geoJSON, label }) => {
  let geoJSONOpts = {
    style: {
      opacity: '33%',
      color: 'green'
    }
  };
  return <FloodMapGeoJSONLayer geoJSON={geoJSON} geoJSONOpts={geoJSONOpts} label={label} />;
}



export default FloodMapGeoJSONLayer;
export {FloodMapGeoJSONLayerPropertyVisualiser, FloodedDefenceAreaVisualiser};